<script>
    import { scaleLinear, scaleTime, scaleDiverging, timeYear, line, area, timeParse, extent, interpolateRdYlBu, scaleThreshold } from 'd3';
    import YAxis from './yAxisV.svelte';
    import XAxis from './xAxisV.svelte';
    let { data, width, highlights } = $props();

    const dates = data.map(d => timeParse('%Y-%m-%d')(d.dt));

    const height = 600;

    const margin = {top: 30, left: 10, bottom: 25, right: 10};

    let chartwidth = $derived(width - margin.left - margin.right);
    const chartheight = height - margin.top - margin.bottom;

    const yDomain = extent(dates);
    const xDomain = [-3, 3];

    const yScale = scaleTime().domain(yDomain).range([0, chartheight]);
    const yTicks = timeYear.every(10).range(...yDomain);
    const xTicks = [-2.5, -2,-1.5, -1,  -0.5, 0, 0.5, 1, 1.5, 2, 2.5];
    const xLabels = [-2, -1, -0.5, 0, 0.5, 1, 2];

    const colorScale = scaleDiverging([2.5, 0, -2.5], interpolateRdYlBu);

    // Sample the diverging scale across the y-domain (oni 3 -> -3) for a vertical gradient
    const gradientStops = Array.from({ length: 25 }, (_, i) => 3 - (i / 24) * 6);

    
    

    const xScale = $derived(
        chartwidth && xDomain ? 
        scaleTime()
            .range([0, chartwidth])
            .domain(xDomain) :
        null
    )

    const lineGen = $derived(
        xScale ? 
        line()
            .y(d => yScale(timeParse('%Y-%m-%d')(d.dt)))
            .x(d => xScale(d.oni)) :
        null
    )

    // Area between the line and the +0.5 baseline (clipped to the El Niño band)
    const ninoArea = $derived(
        xScale ?
        area()
            .y(d => yScale(timeParse('%Y-%m-%d')(d.dt)))
            .x0(xScale(0.5))
            .x1(d => xScale(d.oni)) :
        null
    )

    // Area between the line and the -0.5 baseline (clipped to the La Niña band)
    const ninaArea = $derived(
        xScale ?
        area()
            .y(d => yScale(timeParse('%Y-%m-%d')(d.dt)))
            .x0(xScale(-0.5))
            .x1(d => xScale(d.oni)) :
        null
    )
</script>

<svg {width} {height}>
    <defs>
        <!-- Vertical gradient: color maps to oni value (height), anchored to yScale -->
        <linearGradient
            id="nino-gradient"
            gradientUnits="userSpaceOnUse"
            y1="0" x1={xScale(3)} y2="0" x2={xScale(-3)}
        >
            {#each gradientStops as oni}
                <stop stop-color={colorScale(oni)} offset="{(3 - oni) / 6 * 100}%" />
            {/each}
        </linearGradient>
    </defs>
    
    <YAxis {yScale} {yTicks} {width} {margin}/>
    
    <g transform="translate({margin.left}, {margin.top})">
        <clipPath id="nino">
            <rect x={xScale(0.5)} y=0 width={chartwidth - xScale(0.5)} height={chartheight}></rect>

        </clipPath>
        <clipPath id="nina">
            <rect x=0 y=0 width={xScale(-0.5)} height={chartheight}></rect>
        </clipPath>
        
        <XAxis {xScale} {xTicks} {chartheight} {margin} />
        {#if lineGen}
            <!-- Event area fills, clipped to the ±0.5 bands -->
            <path d={ninoArea(data)} fill="url(#nino-gradient)" opacity=0.3 clip-path="url(#nino)"></path>
            <path d={ninaArea(data)} fill="url(#nino-gradient)" opacity=0.3 clip-path="url(#nina)"></path>

            <!-- Base line -->
            <path d={lineGen(data)} fill="none" stroke="#666" stroke-width=0.5></path>

            <!-- Highlighted line, clipped to the ±0.5 bands -->
            <path d={lineGen(data)} fill="none" stroke="url(#nino-gradient)" stroke-width=2 clip-path="url(#nino)"></path>
            <path d={lineGen(data)} fill="none" stroke="url(#nino-gradient)" stroke-width=2 clip-path="url(#nina)"></path>
        {/if}
        {#each highlights as h}
            {@const datum = data.find(d => d.dt === h.dt)}
            {@const cy = yScale(timeParse('%Y-%m-%d')(h.dt))}
            {@const cx = xScale(datum.oni)}
            <text class="highlight-text" x={cx} y={cy-15} fill="{colorScale(3)}">{h.label}</text>
            <circle {cx} {cy} r="10" fill="none" class="highlight-circle" stroke="{colorScale(3)}"></circle>
        {/each}
    </g>
</svg>

<style lang='scss'>
    .highlight-text {
        text-anchor: middle;
        font-weight:700;
        font-size: 12px;
    }
</style>